import { ActionTypes } from "../../../constants/ActionConstants";

// open campaign confirm form modal
export const openCampaignConfirmFormModal = () => ({
  type: ActionTypes.CampaignConfirmFormModal.OPEN_CAMPAIGN_CONFIRM_MODAL,
});
